<template>
	<div id="app">
		<!-- <transition :name="transitionName"> -->
			<router-view class="body-wrap" />
		<!-- </transition> -->
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		getCommonOption,
		getTemplates,
		getCommonAuthOption
	} from '@/common/api/public.js'
	export default {
		name: 'app',
		data() {
			return {
				transitionName: 'slide-right'
			}
		},
		watch: {
			$route() {
				let isBack = this.$router.isBack
				if (isBack) {
					this.transitionName = 'slide-right'
				} else {
					this.transitionName = 'slide-left'
				}
				this.$router.isBack = false
			}
		},
		created() {
			let commonData = localStorage.getItem('commonData')
			let manual =  localStorage.getItem('p_templates')
			if (commonData && commonData !== '{}') {
				Vue.prototype.commonData = JSON.parse(commonData)
			}
			if (manual && manual !== '{}') {
				Vue.prototype.p_templates = JSON.parse(manual)
			}
		},
		async mounted() {
			// const {
			// 	data
			// } = await getCommonAuthOption()
			// Vue.prototype.commonData = data
			// localStorage.setItem('commonData', JSON.stringify(this.commonData))
			// console.log(this.commonData, '公共数据');
			// 获取模板
			// const res = await getTemplates()
			// console.log(res, '模板下载')
			// Vue.prototype.p_templates = res.data
			// localStorage.setItem('p_templates', JSON.stringify(res.data))
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 16px;
		color: #333;
	}
	
	input::-webkit-outer-spin-button,
	    input::-webkit-inner-spin-button {
	    -webkit-appearance: none;
	}
	input[type="number"]{
	    -moz-appearance: textfield;
	}
	/* .slide-right-enter-active,
	.slide-right-leave-active,
	.slide-left-enter-active,
	.slide-left-leave-active {
		will-change: transform;
		transition: all .5s;
		position: absolute
	}


	.slide-right-enter {

		transform: translate3d(-100%, 0, 0)
	}

	.slide-right-leave-active {

		transform: translate3d(100%, 0, 0)
	}

	.slide-left-enter {

		transform: translate3d(100%, 0, 0)
	}

	.slide-left-leave-active {
		transform: ranslate3d(-100%, 0, 0)
	} */

	/* Webkit 浏览器 */
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background-color: #4979ff;
		border-radius: 5px;
	}

	/* Firefox 浏览器 */
	scrollbar-color: #4979ff #f1f1f1;
	scrollbar-width: thin;

	html,
	body,
	p {
		padding: 0 !important;
		margin: 0 !important;
	}

	p {
		margin-bottom: 0.625rem;
	}

	.research-experience p,
	.form p {
		margin: 15px 0;
	}

	/* .ql-align-center {
		text-align: center;
	} */

	/* 公共样式 */
	.flex {
		display: flex;
		flex-direction: row;
	}

	.wrap {
		flex-wrap: wrap;
	}

	.col-center {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.row-center {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.flex-sb {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.flex-sa {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.flex-center {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.flex-cb {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.el-button.el-button--primary {
		background-color: #4389E0;
		border-color: #4389E0;
	}

	/* 自定义弹出层样式 */
	.el-dialog__header {
		background-color: #4389DF !important;
		padding: 1.125rem 1.25rem !important;
	}

	.el-dialog {
		border-radius: 0.625rem !important;
		overflow: hidden !important;
	}

	.dialog-head {
		margin: 0;
		color: white;
	}

	@media screen and (max-width: 922px) {

		/* 隐藏垂直滚动条 */
		::-webkit-scrollbar {
			width: 0 !important;
		}

		/* 隐藏水平滚动条 */
		::-webkit-scrollbar {
			height: 0 !important;
		}

		scrollbar-width: auto;
	}

	html {
		overflow-x: hidden !important;
	}
</style>